import React from 'react';
import ChooseRregisteredOffersSwitcher from './ChooseRregisteredOffersSwitcher';
interface ChooseRregisteredOffersProps {
  type: string;
  postType: string;
  chosedSugestionUser: IChosedSugestionUser;
  isExpired: boolean;
  is_saled: boolean;

  setisOpenEndModal: (isOpenEndModal: boolean) => void;
  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
}
const ChooseRregisteredOffers = ({
  type,
  postType,
  chosedSugestionUser,
  isExpired,
  is_saled,
  setChosedSugestionUser,
  setisOpenEndModal,
}: ChooseRregisteredOffersProps) => {
  return (
    <div className="flex flex-col w-full gap-4 pb-2">
      <div className="flex justify-between items-center text-gray-6 font-normal text-[18px]">
        <h4>برنده مزاید را انتخاب کنید.</h4>
        <button
          className="icon-close text-[15px]"
          onClick={() => {
            isExpired && setisOpenEndModal(true);
            setChosedSugestionUser({
              isOpenModal: false,
              profile: null,
              type: null,
              guid: null,
              isDelete: false,
            });
          }}
        />
      </div>

      <ChooseRregisteredOffersSwitcher
        is_saled={is_saled}
        postType={postType}
        setChosedSugestionUser={setChosedSugestionUser}
        chosedSugestionUser={chosedSugestionUser}
        type={type}
      />
    </div>
  );
};

export default ChooseRregisteredOffers;
